import React, { useCallback } from 'react';
import { useLocation } from 'react-router';
import * as queryString from 'query-string';

import Button from '@xcritical/button';

import { history } from '@crm-package/app';
import { useDictionary } from '@crm-package/dictionaries';

import { EnvironmentsHeaderName, EnvironmentsWrapper } from './styles';

// TODO Refactoring list
export const EnvironmentsMenu: React.FC = () => {
  const location = useLocation();

  const environments = useDictionary('environment');

  const { environment } = queryString.parse(location.search);

  const handleClick = useCallback(
    (id: number) => () => {
      history.push(`?environment=${id}`);
    },
    []
  );

  return (
    <EnvironmentsWrapper>
      <EnvironmentsHeaderName>Environments</EnvironmentsHeaderName>
      {environments.map(({ id, name }) => (
        <Button
          key={id}
          appearance="filterLink"
          textPosition="left"
          outline={false}
          shouldFitContent
          selected={environment === id.toString()}
          onClick={handleClick(id)}>
          {name}
        </Button>
      ))}
    </EnvironmentsWrapper>
  );
};
